import React, { useState } from "react";
import Dialog from '@material-ui/core/Dialog';
import {
    Box, Button, DialogContent, DialogActions, Switch, Grid,
} from '@material-ui/core';
import { useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { Close } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import emailSend from '../assets/mailsend.png'
import CustomSwitch from '../CustomizedUIs/GreenSwitch'
import CloseButton from "../CustomizedUIs/CloseButton";
const useStyles = makeStyles(theme => ({
    dialog: {
        width: 449,
        borderRadius: 10,
        backgroundColor: '#f3f7fa'
    },
    dialogCloseBtn: {
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        marginLeft: 10
    },
    dialogContent: {
        paddingLeft: 32,
        paddingRight: 35
    },
    levelItem: {
        height: '45px',
        paddingLeft: '4rem'
    },
    expandGroup: {
        width: 241,
        height: 30,
        float: 'right',
        borderRadius: '4px',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    expandText: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: ' #4f5064',
    }, Header: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    }, btnClose: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    }, btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    }, Title: {
        fontFamily: 'UniviaPro',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    constentTitle: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    }, TitleChangeBold: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    }, TitleChange: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '18px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    }
}));

const UpdatePassword = ({ open, handleClose, handleSendMail, data, isSend }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [forceUser, setForceUser] = useState(data.forceChangePassword);
    const dataProvider = useDataProvider();
    const handleChange = (e) => {
        setForceUser(e.target.checked);
    };

    return (

        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" >

            {
                isSend === true ? (
                    <Box width={400} textAlign='center'>
                        <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                            <Typography className={classes.btnClose}>{translate('pos.user.close')}</Typography>
                            <CloseButton onClick={handleClose}/>
                        </Box>
                        <Box display='flex' justifyContent='center' width='100%' mt={2}>
                            <img alt='' src={emailSend} width="230" height="230" />
                        </Box>
                        <Box style={{ marginBottom: '30px' }}>
                            <Typography className={classes.Title}>{translate('pos.user.TitelSendMail')}</Typography>
                            <Typography className={classes.constentTitle} >{translate('pos.user.ConstentSendMail')}</Typography>
                        </Box>


                    </Box>) : (
                        <Box className={classes.dialog}>
                            <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                                <Typography className={classes.btnClose}>{translate('pos.user.close')}</Typography>
                                <CloseButton onClick={handleClose}/>
                            </Box>
                            <DialogContent className={classes.dialogContent}>
                                <Grid container alignItems="center">
                                    <Typography className={classes.TitleChangeBold}>{translate('pos.user.updatefor')}</Typography>
                                    <Typography className={classes.TitleChange} style={{ marginLeft: "5px" }}> {data.username}</Typography>

                                </Grid>
                                <Box mt={2.25} display="flex" justifyContent='space-between' alignItems='center'>

                                    <Box px={1} className={classes.expandGroup}  >
                                        <Typography className={classes.expandText} >{translate(`pos.user.forceuser`).toUpperCase()}</Typography>
                                        <CustomSwitch checked={forceUser} onChange={handleChange} size="small" />
                                    </Box>
                                </Box>
                                <Box mt={2.25} display="flex" justifyContent='space-between' alignItems='center'>
                                    <DialogActions>
                                        <Button
                                            variant="contained"
                                            size="large"
                                            color="primary"
                                            onClick={() => handleSendMail(forceUser)}
                                        > <Typography className={classes.btnCreate}> {translate(`pos.user.sendpassword`)}</Typography></Button>
                                    </DialogActions>
                                </Box>
                            </DialogContent>
                        </Box>
                    )
            }


        </Dialog>

    );
}
export default UpdatePassword